import { Line } from 'react-chartjs-2';

import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);

export type DatasetType = {
  data: number[];
  label?: string;
  borderColor?: string;
  backgroundColor?: string;
};

interface LineChartProps {
  title?: string;
  labels: string[];
  datasets: DatasetType[];
  height?: string | number;
  width?: string | number;
}

export const LineChart = ({
  title,
  labels,
  datasets,
  height,
  width,
}: LineChartProps) => {
  return (
    <Line
      title={title}
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: 'top' as const,
            align: 'start',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 20,
            },
          },
          title: {
            display: true,
            text: title,
          },
        },
      }}
      data={{
        labels,
        datasets,
      }}
      height={height}
      width={width}
    />
  );
};

export default LineChart;
